/**
 * @generated SignedSource<<f418af7d6f9a9f3cfc21108b16f87443>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelay_workedOn$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly object: {
        readonly data: {
          readonly __typename: "ConfluenceBlogPost";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluencePage";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluenceWhiteboard";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraIssue";
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "JiraPlatformComment";
          readonly issue: {
            readonly webUrl: AGG$URL | null | undefined;
          } | null | undefined;
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "JiraServiceManagementComment";
          readonly issue: {
            readonly webUrl: AGG$URL | null | undefined;
          } | null | undefined;
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      };
    };
  }>;
  readonly " $fragmentType": "UserProfilePreviewRelay_workedOn";
};
export type UserProfilePreviewRelay_workedOn$key = {
  readonly " $data"?: UserProfilePreviewRelay_workedOn$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelay_workedOn">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  (v1/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v2/*: any*/)
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelay_workedOn",
  "selections": [
    {
      "concreteType": "ActivityItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ActivityNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "ActivityObject",
              "kind": "LinkedField",
              "name": "object",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluencePageLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluencePage"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceBlogPostLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluenceBlogPost"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceWhiteboardLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluenceWhiteboard"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v2/*: any*/),
                      "type": "JiraIssue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*: any*/),
                      "type": "JiraPlatformComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*: any*/),
                      "type": "JiraServiceManagementComment"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "ActivityConnection"
};
})();

(node as any).hash = "6b43bb5be92ee5881cbe47d50372e37a";

export default node;
